module.exports = __webpack_public_path__ + "static/portfolio-6-32cf4ada0c2df334853cb6e439acab10.jpg";